import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';
import ResetButton from 'Elements/Form/ResetButton';
import SearchPane from 'Elements/SearchPane/SearchPane';

import schema, { Schema as UserParamsSchema } from './schema';

const useStyles = makeStyles(theme => ({
  checkbox: {
    padding: '2px 9px'
  },
  formLabel: {
    margin: '10px 0px 10px 15px',
    fontSize: '12px'
  },
  button: {
    marginLeft: theme.spacing(1)
  }
}));

type Props = {
  onSubmit: FormSubmitHandler<UserParamsSchema>;
};

export default function FilterUsers({ onSubmit }: Props) {
  const classes = useStyles();

  return (
    <SearchPane>
      <Link to={'/users/create'}>
        <Button fullWidth variant="contained" color="primary">
          Lisää uusi käyttäjä
        </Button>
      </Link>
      <Typography variant="h6">Suodattimet</Typography>
      <Form onSubmit={onSubmit} validationSchema={schema} initialValues={{}}>
        <InputField
          fullWidth
          name="search"
          variant="outlined"
          placeholder="Hae nimellä tai sähköpostiosoitteella"
          margin="normal"
          InputLabelProps={{ shrink: true }}
        ></InputField>

        <Grid container justify="flex-end">
          <ResetButton className={classes.button} variant="contained">
            Nollaa
          </ResetButton>
          <SubmitButton
            className={classes.button}
            variant="contained"
            color="secondary"
          >
            Suodata
          </SubmitButton>
        </Grid>
      </Form>
    </SearchPane>
  );
}
